@if (loading) {
  <div class="container" [ngClass]="{ inline: inline, container: !fullScreen, overlay: fullScreen }">
    <p-progressSpinner [style]="{ height: size, width: size }" class="spinner" />
  </div>
}
